import React from 'react'
import { Card, Typography, Avatar, useTheme } from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'

// Sample data
const users = [
  {
    name: 'Jane Doe',
    age: 21,
    timeSlot: '10:00 - 10:30 am',
    avatar: 'https://i.pravatar.cc/150?img=1', // Replace with actual URLs
  },
  {
    name: 'Jane Doe',
    age: 21,
    timeSlot: '10:00 - 10:30 am',
    avatar: 'https://i.pravatar.cc/150?img=2',
  },
  {
    name: 'Jane Doe',
    age: 21,
    timeSlot: '10:00 - 10:30 am',
    avatar: 'https://i.pravatar.cc/150?img=3',
  },
]

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: theme.spacing(2),
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  timeSlot: {
    background: '#FCFCFC',
    borderRadius: '12px',
    padding: theme.spacing(1, 2),
  },
})

const UserCards: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <div>
      {users?.map((user, index) => (
        <Card className={classes?.card} key={index} elevation={0}>
          <div className={classes?.userInfo}>
            <Avatar
              src={user.avatar}
              alt={user.name}
              className={classes?.avatar}
            />
            <div>
              <Typography variant='subtitle1'>{user.name}</Typography>
              <Typography variant='body2' color='textSecondary'>
                {user.age} Years old
              </Typography>
            </div>
          </div>
          <Typography className={classes?.timeSlot}>{user.timeSlot}</Typography>
        </Card>
      ))}
    </div>
  )
}

export default UserCards
